import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table operator responsibility view.
 * @extends JetView
 */
export default class tableOperatorResponsibilityView extends JetView {
    /**
     * Configures the view layout and properties.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        return {
            view: 'datatable', // DataTable view
            id: 'datatable', // Unique identifier for the DataTable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 450 : 0, // Conditional height based on screen width
            columns: [
                // Column definitions for the DataTable
                {
                    id: 'UserId', // Column ID
                    header: _('ID Usuario'), // Column header with localization
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    footer: 'Total:', // Footer content
                },
                {
                    id: 'UserName',
                    header: _('Nombre Usuario'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Betting',
                    header: _('Apostado'),
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        // Number formatting for betting
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'summColumn' }, // Footer content for summation
                },
                {
                    id: 'Profit',
                    header: _('Ganado'),
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        // Number formatting for profit
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'summColumn' },
                },
                {
                    id: 'BettingPending',
                    header: _('Apuestas Pendientes'),
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        // Number formatting for pending betting
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'summColumn' },
                },
                {
                    id: 'ProfitPending',
                    header: _('Ganancias Pendientes'),
                    width: 100,
                    sort: 'int',
                    format: webix.Number.numToStr({
                        // Number formatting for pending profit
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'summColumn' },
                },
            ],
            ready: function () {
                // Event triggered when the DataTable is ready
                if (!this.count()) {
                    // Check if there are no items
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay(
                        // Show overlay message
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                    );
                }
            },
            footer: true, // Enable footer
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            // API endpoint for data fetching
            url: devConfig.geturlApi() + 'es/OperatorResponsibility/GetOperatorResponsibility',
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        var url = grid.data.url; // Store the DataTable URL
        var filter = ''; // Initialize filter string

        // Event listener for filtering data
        this.on(this.app, 'OperatorResponsibility:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'CreatedLocalDate') {
                        // Handle date range for CreatedLocalDate
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else if (object[i][0] == 'ModifiedLocalDate') {
                        // Handle date range for ModifiedLocalDate
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom2=' + date[0];
                        string1 = string1 + '&dateTo2=' + date[1];
                    } else {
                        // Handle other filters
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else if (typeof object[i][1] === 'object') {
                    // Handle object filters
                    var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                    for (var j = 0; j < object2.length; j++) {
                        // Iterate through object filters
                        if (object2[j][1] !== null) {
                            if (object2[j][0] === 'start') {
                                // Handle start date
                                var d = new Date(object2[j][1]);
                                var dateFrom =
                                    'dateFrom=' +
                                    d.getFullYear() +
                                    ':' +
                                    ('00' + (d.getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + d.getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + d.getHours()).slice(-2) +
                                    ':' +
                                    ('00' + d.getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + d.getSeconds()).slice(-2);
                                string1 = string1 + '&' + dateFrom; // Append to query string
                            } else if (object2[j][0] === 'end') {
                                // Handle end date
                                var d = new Date(object2[j][1]);
                                var dateTo =
                                    'dateTo=' +
                                    d.getFullYear() +
                                    ':' +
                                    ('00' + (d.getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + d.getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + d.getHours()).slice(-2) +
                                    ':' +
                                    ('00' + d.getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + d.getSeconds()).slice(-2);
                                string1 = string1 + '&' + dateTo; // Append to query string
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
